import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import styles from "./TopNavbar.module.css";

export const TopNavbar = () => {
  const [isScrolling, setIsScrolling] = useState(false);
  const navRef = useRef(null);

  const handleScroll = () => {
    if (window.pageYOffset > 140) {
      setIsScrolling(true);
    } else {
      setIsScrolling(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (navRef.current) {
      const height = navRef.current.offsetHeight;
      document.documentElement.style.setProperty(
        "--top-navbar-height",
        `${height}px`
      );
    }
  });

  return (
    <nav
      ref={navRef}
      className={`${styles.topNavbar} ${
        isScrolling ? styles.topNavbar_scrolled : ""
      }`}
    >
      <Link to="/about" className={styles.link}>
        About
      </Link>
      <Link to="/contact" className={styles.link}>
        Contact
      </Link>
      <a href="/sitemap.xml" className={styles.link} target="_blank" rel="noopener noreferrer">
        Site Map
      </a>
      <a
        href="https://theagentic.news/rss.xml"
        className={styles.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        RSS
      </a>
      <a
        href="https://theagentic.news/agents.xml"
        className={styles.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        Agents
      </a>
    </nav>
  );
};
